const Chip = ({ active, onClick, children, testId }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`h-10 shrink-0 rounded-lg border px-3.5 text-sm font-medium transition-colors duration-150 ${
      active ? "border-foreground bg-foreground text-background" : "bg-card text-muted-foreground hover:text-foreground"}`}>
    {children}
  </button>
);

export const ChipRow = ({ label, options, value, onChange, prefix }) => (
  <div className="flex items-center gap-2">
    <span className="hidden w-14 shrink-0 text-xs font-medium text-muted-foreground sm:block">{label}</span>
    <div className="-mx-4 flex gap-2 overflow-x-auto px-4 pb-1 [scrollbar-width:none] sm:mx-0 sm:px-0">
      <Chip active={!value} onClick={() => onChange(null)} testId={`${prefix}-filter-all`}>All</Chip>
      {options.map((o) => (
        <Chip key={o.key} active={value === o.key} onClick={() => onChange(o.key)} testId={`${prefix}-filter-${o.key.toLowerCase()}`}>{o.label}</Chip>
      ))}
    </div>
  </div>
);
